import { ref } from "vue";

export function useFullScreen() {
  const isFullscreen = ref(false);
  const playerID = ref('');

  /** Omit `requestingPlayerID` for an app-driven toggle; it owns nothing and always wins. */
  const toggle = (shouldEnter: boolean, requestingPlayerID?: string) => {
    const html = document.getElementsByTagName('html')[0];

    if (shouldEnter) {
      isFullscreen.value = true;
      html.classList.add('fullscreen');
      if (!!requestingPlayerID && playerID.value != requestingPlayerID) {
        playerID.value = requestingPlayerID;
      }
      return;
    }

    if (!!requestingPlayerID && !!playerID.value && playerID.value != requestingPlayerID) {
      return;
    }

    isFullscreen.value = false;
    html.classList.remove('fullscreen');
    playerID.value = '';
  };

  return {
    isFullscreen,
    playerID,
    toggle
  }
}
